<section class="adobe-partner-section" style="background-image: url(assets/images/home-new/202316145634-442CHAN63.png)">
    <div class="container-fluid">
        <div class="row main_row">
            <ion-slides pager="false" [options]="slides" #slides>
                <ion-slide class="inside-sl-box">
                    <div class="col-md-6 content-adobe-partner">
                        <h2>ADOBE SOLUTION PARTNER</h2>
                        <p>With an excellent experience as a Bronze Solution Partner of Adobe products, Vidhema
                            Technologies focuses on delivering unparalleled solutions with Adobe Experience Cloud
                            integrations & implementations. We ensure to offer compelling Adobe services to our
                            clientele. As a certified Adobe Partner Agency, the expertise that we dwell on is to empower
                            & boost your business.</p>
                        <a routerLink="/hire-magento-developers.html" href="" class="cta-button-hire">Hire our
                            Experts</a>
                    </div>
                    <div class="col-md-6 text-center">
                        <img width="469" height="501"
                            src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/adobe_solution-768x236.png?alt=media&token=b2aae1d1-f0a5-4903-848e-4292d24c94c4"
                            alt="Adobe Partner" title="adobe-partner-image">
                    </div>
                </ion-slide>
                <ion-slide class="inside-sl-box">
                    <div class="col-md-6 content-adobe-partner">
                        <h2>Shopify E-commerce Solutions</h2>
                        <p>Businesses and entrepreneurs wishing to make an important difference in the online industry
                            utilize Shopify E-commerce Solutions as their platform of choice. Utilize it to improve your
                            online visibility. Shopify offers an array of options, including customizable themes, secure
                            payment methods, and marketing integrations, all of which are accompanied by an accessible
                            UI. Shopify has all the resources you require to build a reliable and prosperous online
                            business, whether you're expanding an existing store or starting a new one.</p>
                        <a routerLink="/hire-shopify-developers.html" href="" class="cta-button-hire">Hire our
                            Experts</a>
                    </div>
                    <div class="col-md-6 text-center">
                        <img width="469" height="501"
                            src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Untitled-5%20(1).jpg?alt=media&token=bd73c28f-c0c4-4ed1-a532-9df1ba293566"
                            alt="Shopify" title="Shopify">
                    </div>
                </ion-slide>
                <ion-slide class="inside-sl-box">
                    <div class="col-md-6 content-adobe-partner">
                        <h2>AEM Digital Experience Platforms</h2>
                        <p>Digital experience platforms from Adobe Experience Manager (AEM) enable companies to create
                            remarkable consumer experiences. Brands can connect consumers with relevant and personalized
                            content across many touchpoints by using AEM to streamline content management and delivery.
                            With the flexibility and strength of AEM, you can completely change your online presence and
                            establish new, meaningful connections with your audience.</p>
                        <a routerLink="/aem-cms-development.html" href="" class="cta-button-hire">Hire our Experts</a>
                    </div>
                    <div class="col-md-6 text-center">
                        <img width="469" height="501"
                            src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/aem-(1).jpg?alt=media&token=58fe9b15-537b-42c5-98ac-c7d8827dec4d"
                            alt="AEM" title="AEM">
                            <!-- <div class="main">
                                <div class="partner">
                                    <img width="30"  height="30"
                                    src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/aem.jpg?alt=media&token=b6d4842f-7fb0-48c9-943b-1b0e851ae251"
                                    alt="aem" title="aem">
                                   </div> 
                                   <div class="adobe">
                                    <div class="acc">
                                        <img width="40px" height="40px"
                                        src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/acc.jpg?alt=media&token=aecda2a8-cf20-45f4-a7cd-6baf4a7eef79"
                                        alt="acc" title="acc">
                                       </div>
                                        <div class="base">
                                            <h3>Adobe<br>Commerce<br>Cloud</h3>
                                       </div>
                                   </div>
                                  
                            </div> -->
                          
                    </div>
                </ion-slide>
                <ion-slide class="inside-sl-box">
                    <div class="col-md-6 content-adobe-partner">
                        <h2>Salesforce Automation Tools</h2>
                        <p>Explore the benefits of Salesforce Automation Tools in making your business more efficient.
                            This overview covers essential features such as automated data entry, workflow
                            customization, and seamless integration, all designed to simplify tasks and enhance
                            productivity without the use of AI. Perfect for businesses looking to improve operations
                            through practical automation.</p>
                        <a routerLink="/salesforce-development.html" href="" class="cta-button-hire">Hire our
                            Experts</a>
                    </div>
                    <div class="col-md-6 text-center">
                        <img width="469" height="501"
                            src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/sap.jpg?alt=media&token=2f44beaa-f416-43a3-8243-937a1ba54956"
                            alt="Salesforce" title="Salesforce">
                    </div>
                </ion-slide>
                <ion-slide class="inside-sl-box">
                    <div class="col-md-6 content-adobe-partner">
                        <h2>Microsoft Dynamics ERP Solutions</h2>
                        <p>Discover how Microsoft Dynamics ERP Solutions can streamline your business operations and
                            improve efficiency. Our comprehensive ERP systems offer real-time data insights, financial
                            management, supply chain optimization, and customer relationship management to empower your
                            organization. Learn how Vidhema can help you implement and customize Microsoft Dynamics to
                            meet your specific business needs, ensuring seamless integration and improved performance.
                        </p>
                        <a routerLink="/microsoft-dynamic.html" href="" class="cta-button-hire">Hire our Experts</a>
                    </div>
                    <div class="col-md-6 text-center">
                        <img width="469" height="501"
                            src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/microsoft.jpg?alt=media&token=b7d192e4-c071-48b0-a4c2-6e79c77818fc"
                            alt="microsoft-dynamic" title="microsoft-dynamic">
                    </div>
                </ion-slide>
              
                
               
                
                <ion-slide class="inside-sl-box">
                    <div class="col-md-6 content-adobe-partner">
                        <h2>SAP Business Analytics Solutions</h2>
                        <p>Transform your data into actionable insights with SAP Business Analytics Solutions. Designed
                            to improve your business operations, SAP offers advanced features for real-time reporting,
                            data analysis, and performance monitoring. Leverage these tools to understand trends,
                            identify opportunities, and enhance decision-making processes, all while maintaining a clear
                            view of your business performance.</p>
                        <a routerLink="/sap-solution.html" href="" class="cta-button-hire">Hire our Experts</a>
                    </div>
                    <div class="col-md-6 text-center">
                        <img width="469" height="470"
                            src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/Untitled-5.jpg?alt=media&token=a59264b7-03bd-4221-acad-a4fbc6922aaf"
                            alt="sap-solution" title="sap-solution">
                    </div>
                </ion-slide>
          
                <!-- <div class="slider-buttons">
                    <button (click)="prevSlide()">Previous</button>
                    <button (click)="nextSlide()">Next</button>
                </div> -->

            </ion-slides>
            <ion-button name="Previous" title="Previous" class="succprenext" (click)="slides.slidePrev()"> <i class="fa fa-angle-left"
                aria-hidden="true"></i> </ion-button>
        <ion-button name="Next" title="Next" class="succprenext nextsucc" (click)="slides.slideNext()"> <i class="fa fa-angle-right"
                aria-hidden="true"></i> </ion-button>
        </div>
       
       
    </div>
</section>